import { render, staticRenderFns } from "./DatacenterCheckbox.vue?vue&type=template&id=63a17c80&scoped=true&"
import script from "./DatacenterCheckbox.vue?vue&type=script&lang=js&"
export * from "./DatacenterCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./DatacenterCheckbox.vue?vue&type=style&index=0&id=63a17c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a17c80",
  null
  
)

export default component.exports